import { Signup, Signin, InstallApp, NotAllowed, GoogleAuthorizing, ApiAccess, terms,support, userExtension, RequestInitiate, PasswordReset, domain_authorized, verfication,userchangepassword,esaReporting} from './components'


export default [
    {
      name: 'signup',
      path: '/signup',
      component: Signup,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.login',
      path: '/login',
      component: Signin,
      meta: { requiresAuth: false },
    },
    // {
    //   name: 'auth.securelogin',
    //   path: '/secure-login',
    //   component: Signin1,
    //   meta: { requiresAuth: false },
    // },
    // {
    //   name: 'auth.reset',
    //   path: '/reset/:token',
    //   component: reset,
    //   meta: { requiresAuth: false },
    // },
    {
      name: 'auth.register',
      path: '/register',
      component: Signup,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.gmail',
      path: '/google-authorizing',
      component: GoogleAuthorizing,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.autherizing',
      path: '/authorizing',
      component: GoogleAuthorizing,
      meta: { requiresAuth: false, title: "Authorizing" },
    },
    {
      name: 'auth.installApp',
      path: '/installApp',
      component: InstallApp,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.notAllowed',
      path: '/notAllowed',
      component: NotAllowed,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.apiaccess',
      path: '/apiaccess',
      component: ApiAccess,
      meta: { requiresAuth: false },  
    },
    {
      name: 'auth.terms',
      path: '/terms',
      component: terms,
      meta: { requiresAuth: false }, 
    },
    {
      name: 'auth.privacy',
      path: '/privacy',
      component: terms,
      meta: { requiresAuth: false },    
    },
    {
      name: 'auth.userExtension',
      path: '/userExtension',
      component: userExtension,
      meta: { requiresAuth: false },    
    },
    {
      name: 'auth.RequestInitiate',
      path: '/requestinitiate/:id',
      component: RequestInitiate,
      meta: { requiresAuth: false },    
    },
    {
      name: 'auth.PasswordReset',
      path: '/auth/resetpassword/:token', 
      component: PasswordReset,
      meta: { requiresAuth: false },    
    },
    {
      name: 'domain_authorized',
      path: '/domain_authorized/:domain', 
      component: domain_authorized,
      meta: { requiresAuth: false },    
    },
    {
        name: 'verification',
        path: '/qrcode/verification',
        component: verfication,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.UserChangedPassword',
        path: '/auth/userchangepassword',
        component: userchangepassword,
        meta: { requiresAuth: false },
    },
    {
      name: 'auth.esaReporting',
      path: '/esareporting',
      component: esaReporting,
      meta: { requiresAuth: false },    
    },
       {
      name: 'auth.support',
      path: '/support',
      component: support,
      meta: { requiresAuth: false },
    }
]



// WEBPACK FOOTER //
// ./src/app/auth/routes/index.js